import { Component, ViewContainerRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export interface ContinueDialogResult {
  navigateToCart?: boolean;
}

@Component({
  selector: 'app-continue-dialog',
  templateUrl: './continue-dialog.component.html',
  styleUrls: ['./continue-dialog.component.scss'],
})
export class ContinueDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ContinueDialogComponent, ContinueDialogResult>,
    private viewContainerRef: ViewContainerRef
  ) {}

  public navigateToCart() {
    this.dialogRef.close({ navigateToCart: true });
  }

  public get height(): number {
    const dialogElement = this.viewContainerRef.element.nativeElement.parentElement as HTMLElement;
    const { height } = dialogElement.getBoundingClientRect();

    return height;
  }
}
